import {
  ADDRESS_ERROR,
  ADDRESS_LOADING,
  ADDRESS_REQUEST,
  ADDRESS_SUCCESS,
  AMOUNT_OWED_ERROR,
  AMOUNT_OWED_LOADING,
  AMOUNT_OWED_REQUEST,
  AMOUNT_OWED_SUCCESS,
  CHECK_PERSONAL,
  CLAIMED_DEPENDENTS_ERROR,
  CLAIMED_DEPENDENTS_LOADING,
  CLAIMED_DEPENDENTS_REQUEST,
  CLAIMED_DEPENDENTS_SUCCESS,
  COMPLIANCE_STATUS_ERROR,
  COMPLIANCE_STATUS_LOADING,
  COMPLIANCE_STATUS_REQUEST,
  COMPLIANCE_STATUS_SUCCESS,
  DELETE_AMOUNT_OWED_ITEM,
  DELETE_AMOUNT_SUCCESS,
  EDIT_AMOUNT_OWED_ITEM,
  EDIT_AMOUNT_OWED_SUCCESS,
  LEVY_REQUEST,
  LEVY_SUCCESS,
  MARITAL_STATUS_ERROR,
  MARITAL_STATUS_LOADING,
  MARITAL_STATUS_REQUEST,
  MARITAL_STATUS_SUCCESS,
  NEW_AMOUNT_OWED_SUCCESS,
  POST_ADDRESS,
  POST_CLAIMED_DEPENDENTS,
  POST_COMPLIANCE_STATUS,
  POST_LEVY,
  POST_MARITAL_STATUS,
  POST_NEW_AMOUNT_OWED_ITEM,
  POST_PROFILE,
  PROFILE_ERROR,
  PROFILE_LOADING,
  PROFILE_REQUEST,
  PROFILE_SUCCESS,
  PERSONAL_REQUESTS,
  FILTER_AMOUNT_OWED_YEARS,
  SET_AMOUNT_OWED_YEARS,
  COUNTIES_REQUEST,
  COUNTIES_SUCCESS,
  POWER_OF_ATTORNEY_REQUEST,
  POWER_OF_ATTORNEY_SUCCESS,
  POWER_OF_ATTORNEY_ERROR,
  POST_REVENUE_OFFICER_FLAG,
} from '@/app/personal/store/types';
import { REFRESH_REQUEST } from '@/app/auth/store/types';

import { http } from '@/api';

export const actions = {
  [CHECK_PERSONAL]: ({ getters, dispatch }) => {
    const userId = getters.getUserId;
    dispatch(PROFILE_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(PERSONAL_REQUESTS);
      }
    });
    dispatch(MARITAL_STATUS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(PERSONAL_REQUESTS);
      }
    });
    dispatch(ADDRESS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(PERSONAL_REQUESTS);
      }
    });
    dispatch(COMPLIANCE_STATUS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(PERSONAL_REQUESTS);
      }
    });
    dispatch(AMOUNT_OWED_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(PERSONAL_REQUESTS);
      }
    });
    dispatch(LEVY_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(PERSONAL_REQUESTS);
      }
    });
    dispatch(CLAIMED_DEPENDENTS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(PERSONAL_REQUESTS);
      }
    });
  },
  [PERSONAL_REQUESTS]: ({ dispatch }, userId) => {
    dispatch(REFRESH_REQUEST).then(() => {
      dispatch(PROFILE_REQUEST);
      dispatch(MARITAL_STATUS_REQUEST, userId);
      dispatch(ADDRESS_REQUEST, userId);
      dispatch(COMPLIANCE_STATUS_REQUEST, userId);
      dispatch(AMOUNT_OWED_REQUEST, userId);
      dispatch(LEVY_REQUEST, userId);
      dispatch(CLAIMED_DEPENDENTS_REQUEST, userId);

      return false;
    });
  },
  [PROFILE_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(PROFILE_LOADING);
    http.get(`/personal/apps/${userId}/profile`)
      .then((resp) => {
        commit(PROFILE_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(PROFILE_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_PROFILE]: ({ commit }, userData) => new Promise(((resolve, reject) => {
    commit(PROFILE_LOADING);
    http.put(`/personal/apps/${userData.userId}/profile`, userData.profile)
      .then((resp) => {
        commit(PROFILE_SUCCESS, resp.config.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(PROFILE_ERROR);
        reject(err);
      });
  })),
  [MARITAL_STATUS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(MARITAL_STATUS_LOADING);
    http.get(`/personal/apps/${userId}/marital-status`)
      .then((resp) => {
        commit(MARITAL_STATUS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(MARITAL_STATUS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_MARITAL_STATUS]: ({ commit }, maritalStatus) => new Promise(((resolve, reject) => {
    commit(MARITAL_STATUS_LOADING);
    http.put(`/personal/apps/${maritalStatus.userId}/marital-status`, maritalStatus.maritalStatusData)
      .then((resp) => {
        commit(MARITAL_STATUS_SUCCESS, resp.config.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(MARITAL_STATUS_ERROR);
        reject(err);
      });
  })),
  [ADDRESS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(ADDRESS_LOADING);
    http.get(`/personal/apps/${userId}/address`)
      .then((resp) => {
        commit(ADDRESS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ADDRESS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_ADDRESS]: ({ commit }, address) => new Promise(((resolve, reject) => {
    commit(ADDRESS_LOADING);
    http.put(`/personal/apps/${address.userId}/address`, address.addressData)
      .then((resp) => {
        commit(ADDRESS_SUCCESS, resp.config.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ADDRESS_ERROR);
        reject(err);
      });
  })),
  [COMPLIANCE_STATUS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(COMPLIANCE_STATUS_LOADING);
    http.get(`/personal/apps/${userId}/compliance-status`)
      .then((resp) => {
        commit(COMPLIANCE_STATUS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(COMPLIANCE_STATUS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_COMPLIANCE_STATUS]: ({ commit }, complianceStatus) => new Promise(((resolve, reject) => {
    commit(COMPLIANCE_STATUS_LOADING);
    http.put(`/personal/apps/${complianceStatus.userId}/compliance-status`, complianceStatus.complianceStatusData)
      .then((resp) => {
        commit(COMPLIANCE_STATUS_SUCCESS, resp.config.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(COMPLIANCE_STATUS_ERROR);
        reject(err);
      });
  })),
  [AMOUNT_OWED_REQUEST]: ({ commit, dispatch }, userId) => new Promise(((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.get(`/personal/apps/${userId}/amount-owed`)
      .then((resp) => {
        commit(AMOUNT_OWED_SUCCESS, resp.data);
        dispatch(FILTER_AMOUNT_OWED_YEARS);
        resolve(resp);
      })
      .catch((err) => {
        commit(AMOUNT_OWED_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        } else {
          dispatch(FILTER_AMOUNT_OWED_YEARS);
        }
      });
  })),
  [LEVY_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.get(`/personal/apps/${userId}/levy`)
      .then((resp) => {
        commit(LEVY_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(AMOUNT_OWED_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_LEVY]: ({ commit }, amountOwed) => new Promise(((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.put(`/personal/apps/${amountOwed.userId}/levy`, amountOwed.levyData)
      .then((resp) => {
        commit(LEVY_SUCCESS, resp.config.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(AMOUNT_OWED_ERROR);
        reject(err);
      });
  })),
  [POST_NEW_AMOUNT_OWED_ITEM]: ({ commit, dispatch },
    newItemData) => new Promise(((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.post(`/personal/apps/${newItemData.userId}/amount-owed`, newItemData.newItem)
      .then((resp) => {
        commit(NEW_AMOUNT_OWED_SUCCESS, resp);
        dispatch(FILTER_AMOUNT_OWED_YEARS);
        resolve(resp);
      })
      .catch((err) => {
        commit(AMOUNT_OWED_ERROR);
        reject(err);
      });
  })),
  [DELETE_AMOUNT_OWED_ITEM]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.delete(`/personal/apps/${item.userId}/amount-owed/${item.id}`)
      .then((resp) => {
        commit(DELETE_AMOUNT_SUCCESS, item.id);
        dispatch(FILTER_AMOUNT_OWED_YEARS);
        resolve(resp);
      })
      .catch((err) => {
        commit(AMOUNT_OWED_ERROR);
        reject(err);
      });
  })),
  [EDIT_AMOUNT_OWED_ITEM]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.put(`/personal/apps/${item.userId}/amount-owed/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_AMOUNT_OWED_SUCCESS, item);
        dispatch(FILTER_AMOUNT_OWED_YEARS);
        resolve(resp);
      })
      .catch((err) => {
        commit(AMOUNT_OWED_ERROR);
        reject(err);
      });
  })),
  [CLAIMED_DEPENDENTS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(CLAIMED_DEPENDENTS_LOADING);
    http.get(`/personal/apps/${userId}/claimed-dependents`)
      .then((resp) => {
        commit(CLAIMED_DEPENDENTS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(CLAIMED_DEPENDENTS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_CLAIMED_DEPENDENTS]: ({ commit }, claimedDependents) => new Promise(((resolve, reject) => {
    commit(CLAIMED_DEPENDENTS_LOADING);
    http.put(`/personal/apps/${claimedDependents.userId}/claimed-dependents`, claimedDependents.claimedDependentsData)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        commit(CLAIMED_DEPENDENTS_ERROR);
        reject(err);
      });
  })),
  [COUNTIES_REQUEST]: ({ commit }, abbreviation) => new Promise(((resolve, reject) => {
    commit(ADDRESS_LOADING);
    http.get(`/lookup/state/${abbreviation}/counties`)
      .then((resp) => {
        commit(COUNTIES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ADDRESS_ERROR);
        reject(err);
      });
  })),
  [FILTER_AMOUNT_OWED_YEARS]: ({ commit, getters }) => {
    const minPastDelta = 27;
    const min = new Date().getFullYear() - minPastDelta;
    const max = new Date().getFullYear();

    const years = [];
    for (let i = min; i <= max; i += 1) {
      years.push(i.toString());
    }
    const usedYears = getters.getAmountOwedItems.map(item => item.year.toString());
    const possibleYears = years.filter(item => usedYears.indexOf(item) < 0);

    commit(SET_AMOUNT_OWED_YEARS, possibleYears);
  },
  // eslint-disable-next-line max-len
  [POWER_OF_ATTORNEY_REQUEST]: ({ commit, dispatch }, requestData) => new Promise((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.get(`/personal/apps/${requestData.userId}/power-of-attorney`, {
      responseType: 'blob',
    })
      .then((resp) => {
        commit(POWER_OF_ATTORNEY_SUCCESS);
        resolve(resp);
      })
      .catch((err) => {
        commit(POWER_OF_ATTORNEY_ERROR);
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              dispatch(POWER_OF_ATTORNEY_REQUEST, requestData);
            });
        } else {
          reject(err);
        }
      });
  }),
  [POST_REVENUE_OFFICER_FLAG]: ({ commit },
    revenueOfficerFlag) => new Promise(((resolve, reject) => {
    commit(AMOUNT_OWED_LOADING);
    http.put(`/personal/apps/${revenueOfficerFlag.userId}/revenue-officer-flag`, revenueOfficerFlag.data)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        commit(AMOUNT_OWED_ERROR);
        reject(err);
      });
  })),
};
